import styled from 'styled-components';
import Slider from "react-slick";
import theme from "./../../styles/theme"

export const SliderCustom = styled(Slider)`
    margin: 30px;

    @media (max-width: ${theme.breakpoints.tablet}) {
      margin: 0;
    }

    .slick-next{
      right: 0;
      height: 100%;
      width: 50px;

      &::before{
        content: '';
        width: 15px;
        height: 45px;
        top: 50%;
        position: absolute;
        background-image: url();

        @media (max-width: ${theme.breakpoints.tablet}) {
          top: 45%;
        }
      }
    }
    .slick-prev{
      left: 0;
      height: 100%;
      width: 50px;
      z-index: 1;

      @media (max-width: ${theme.breakpoints.tablet}) {
        margin-left: 0;
      }
      &::before{
        content: '';
        width: 15px;
        height: 45px;
        top: 50%;
        position: absolute;
        background-image: url();

        @media (max-width: ${theme.breakpoints.tablet}) {
          top: 45%;
        }
      }
    }
`;
